import { render, staticRenderFns } from "./TransferList.vue?vue&type=template&id=9d46df64"
import script from "./TransferList.vue?vue&type=script&lang=js"
export * from "./TransferList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports